Vue.component("max-user-increase", {
    props: {
        plan: {
            required: true
        },
        user: {
            required: true
        },
        companys: {
            required: false
        },
        pricing_group: {
            required: false
        },
        old_staffs: {
            required: true
        },
        scriptendpoint: ""
    },

    data: function() {
        return {
            redirect_form_key: [],
            staffs: 1,
            instantlink: "",
            payment_token: "",
            instant_eft_success: false,
            forms: {
                webinarCheckout: $.extend(
                    true,
                    new AppForm({
                        busy: false,
                        paymentOption: "",
                        card: null,
                        terms: false,
                        errors: []
                    }),
                    App.forms.webinarCheckout
                )
            },
            addingNewCard: false,
            newcard: {
                number: "",
                holder: "",
                exp_month: "",
                exp_year: "",
                cvv: "",
                return: "",
                errors: [],
                _token: window.App.csrfToken
            },
            threeDs: {
                url: "",
                connector: "",
                MD: "",
                TermUrl: "",
                PaReq: ""
            },
            readyForThreeDs: false,
            checkoutId: null,
            entityId: null
        };
    },

    computed: {
        total: function() {
            var price = this.plan.price;
            var totatStaffsIncludeExtras =
                parseInt(this.staffs) + parseInt(this.old_staffs);
            for (var i = 0; i < this.pricing_group.length; i++) {
                if (
                    totatStaffsIncludeExtras >=
                        this.pricing_group[i].min_user &&
                    totatStaffsIncludeExtras <= this.pricing_group[i].max_user
                ) {
                    price = this.pricing_group[i].price;
                }
                if (
                    totatStaffsIncludeExtras >=
                        this.pricing_group[i].min_user &&
                    this.pricing_group[i].max_user == 0
                ) {
                    price = this.pricing_group[i].price;
                }
            }
            var total = price * this.staffs;
            return total.toFixed(2);
        }
    },
    created() {},
    ready: function() {
        window.addEventListener("message", event => {
            if (typeof event.data == "string") {
                try {
                    eval(event.data);
                    setTimeout(() => {
                        this.forms.webinarCheckout.busy = false;
                        swal.close();
                    }, 2000);
                } catch (e) {
                    this.forms.webinarCheckout.busy = false;
                    // swal.close()
                }
            }
        });
    },

    mounted() {
        this.loadPeachScript();
    },

    methods: {
        loadPeachScript: function() {
            return new Promise((resolve, reject) => {
                if (window.Checkout) {
                    return resolve();
                }

                const script = document.createElement("script");
                script.src = this.scriptendpoint;
                script.onload = resolve;
                script.onerror = reject;

                console.log(this.scriptendpoint);

                document.head.appendChild(script);
            });
        },

        closeModal() {
            $("#checkout_model").modal("hide");
            this.checkoutId = null;
        },

        handleSuccess(event) {
            this.closeModal();
        },
        popEft() {
            this.process();
            this.forms.webinarCheckout.busy = true;
            this.getEftLink();
        },

        /**
         * Add New Card
         */
        addCard() {
            this.newcard.return = `/dashboard/company/renew_company_subscription/${this.user.id}?threeDs=yes`;

            this.processPayment();

            this.$http
                .post("/account/billing", this.newcard)
                .then(response => {
                    if (
                        response.data.redirect === undefined ||
                        response.data.redirect === null
                    ) {
                        this.saveCard(response.data.id);
                        this.addingNewCard = false;
                    } else {
                        this.threeDs.url = response.data.redirect.url;
                        for (
                            var i =
                                response.data.redirect.parameters.length - 1;
                            i >= 0;
                            i--
                        ) {
                            this.redirect_form_key.push({
                                form_key:
                                    response.data.redirect.parameters[i].name,
                                form_value:
                                    response.data.redirect.parameters[i].value
                            });
                            this.threeDs[
                                response.data.redirect.parameters[i].name
                            ] = response.data.redirect.parameters[i].value;
                        }
                        this.readyForThreeDs = true;
                        swal.close();
                    }
                })
                .catch(errors => {
                    this.newcard.errors = errors.data;
                    swal.close();
                });
        },

        /**
         * Save User Card
         */
        saveCard(id) {
            this.$http
                .post("/account/billing/card", {
                    id: id,
                    _token: window.App.csrfToken
                })
                .then(response => {
                    this.user.cards.push(response.data.card);
                    this.forms.webinarCheckout.card = response.data.card.id;
                    swal.close();
                })
                .catch(errors => {
                    if (errors.number) {
                        swal({
                            type: "error",
                            title: "Whoops",
                            text: errors.number
                        });
                    }
                });
        },

        cancelPayment: function() {
            this.forms.webinarCheckout.busy = false;
        },

        getEftLink: async function() {
            this.processPayment();
            this.showModal = true;
            await this.loadPeachScript();
            let data = {
                plan_id: this.plan.id,
                staffs: this.staffs
            };

            this.$http
                .post("/instant-eft", data)
                .then(async response => {
                    const res = response.data;

                    if (!res.checkoutId || !res.entityId) {
                        return;
                    }

                    this.checkoutId = res.checkoutId;
                    this.entityId = res.entityId;

                    await this.$nextTick();

                    $("#checkout_model").modal("show");

                    setTimeout(() => {
                        swal.close();
                        this.initCheckout();
                    }, 300);
                })
                .catch(error => {
                       let message = "Unable to process your request!";

    if (error.status == 422) {
        message = error.data.message;
    }

    swal({
        type: "warning",
        title: "Error",
        text: message,
        showConfirmButton: true
    });
                    this.forms.webinarCheckout.busy = false;
                    return;
                });
        },
        initCheckout: function() {
            const checkout = window.Checkout.initiate({
                key: this.entityId,
                checkoutId: this.checkoutId,

                options: {
                    theme: {
                        brand: {
                            primary: "#ff0000"
                        },
                        cards: {
                            background: "#00ff00",
                            backgroundHover: "#F3F3F4"
                        }
                    },

                    paymentMethods: {
                        include: [
                            "CARD",
                            "OZOW",
                            "MASTERPASS",
                            "MOBICRED",
                            "PAYFLEX",
                            "1FORYOU",
                            "PAYSHAP",
                            "PAYBYBANK",
                            "CAPITECPAY",
                            "NEDBANKDIRECTEFT",
                            "ABSAEFT",
                            "PEACHEFT"
                        ]
                    },

                    ordering: {
                        OZOW: 1,
                        CARD: 2,
                        MASTERPASS: 3,
                        MOBICRED: 4,
                        PAYFLEX: 5,
                        "1FORYOU": 6,
                        PAYSHAP: 7,
                        PAYBYBANK: 8,
                        CAPITECPAY: 9,
                        NEDBANKDIRECTEFT: 10,
                        ABSAEFT: 11,
                        PEACHEFT: 12
                    }
                },

                events: {
                    onCompleted: event => {
                        const resultCode = event.result.code || "";

                        const message =
                            event.result.description ||
                            "Payment response received";

                        const isSuccess = /^(000\.000\.|000\.100\.1|000\.[36]|000\.400\.[1][12]0)/.test(
                            resultCode
                        );

                        if (isSuccess) {
                            swal({
                                type: "success",
                                title: "Payment Successful",
                                text: message,
                                showConfirmButton: true
                            });
                            this.instant_eft_success = true;
                            this.sendRegistration();
                        } else {
                            swal({
                                type: "error",
                                title: "Payment Failed",
                                text: message,
                                showConfirmButton: true
                            });

                            this.forms.webinarCheckout.busy = false;
                            return;
                        }
                    },
                    onCancelled: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text: "Your Payment has Cancelled, please try again"
                        });
                        swal.close();
                        this.forms.webinarCheckout.busy = false;
                    },
                    onExpired: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text:
                                "Your Payment has Session Expired, please try again"
                        });
                        swal.close();
                        this.forms.webinarCheckout.busy = false;
                    }
                }
            });

            checkout.render("#payment-form");
        },
        startListener: function() {
            var pusher = new Pusher("5e9e56a5a0ebaf5484b0", {
                cluster: "mt1"
            });

            var channel = pusher.subscribe("instantefts");

            channel.bind(
                "App\\Events\\InstantEftNotificationReceived",
                data => {
                    if (this.payment_token == data.payment_key) {
                        if (data.success === true) {
                            this.process();
                            this.instant_eft_success = true;
                            this.sendRegistration();
                        } else {
                            this.cancelPayment();
                            swal({
                                type: "error",
                                title: "Error",
                                text:
                                    "Your Payment has failed, please try again"
                            });
                        }
                    }
                }
            );
        },

        process: function() {
            swal({
                title: "",
                text:
                    '<i id="busy" class="fa fa-spinner fa-pulse" style="font-size: 8em; color: #ffffff;"></i>',
                html: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: false,
                showConfirmButton: false,
                closeOnCancel: false,
                customClass: "no-bg"
            });
        },

        register: function() {
            this.forms.webinarCheckout.errors.forget();
            this.forms.webinarCheckout.busy = true;
            //this.process();
            this.sendRegistration();
        },
        processPayment: function() {
            swal({
                type: "warning",
                title: "Payment Processing",
                text:
                    "Please wait while we are processing your payment.Do not Refresh page or close browser"
            });
        },
        sendRegistration: function() {
            if (
                this.forms.webinarCheckout.paymentOption == "eft" &&
                this.instant_eft_success == false
            ) {
                this.forms.webinarCheckout.busy = true;
                return;
            }

            if (
                this.forms.webinarCheckout.paymentOption == "cc" &&
                !this.forms.webinarCheckout.card
            ) {
                swal({
                    type: "warning",
                    title: "Error",
                    text:
                        "Unable to purchase without credit card, please select credit card"
                });
                this.forms.webinarCheckout.busy = false;
                return;
            }

            var payload = {
                terms: this.forms.webinarCheckout.terms,
                card: this.forms.webinarCheckout.card,
                paymentOption: this.forms.webinarCheckout.paymentOption,
                staff_count: this.staffs,
                user_id: this.user.id,
                plan_id: this.plan.id
            };

            this.processPayment();

            this.$http
                .post("/dashboard/company/company_subscription/renew", payload)
                .success(function(response) {
                    this.forms.webinarCheckout.busy = false;
                    swal.close();
                    window.location = "/dashboard/company";
                })
                .error(function(errors) {
                    this.forms.webinarCheckout.busy = false;
                    swal.close();
                    this.forms.webinarCheckout.errors.set(errors);
                });
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/orders/max_user_increase.js